
import { RootTest } from 'dialer'

export class TestSeqStatus {
    static readonly SEQ_FINISHED = 'SEQ_FINISHED' // path test point seq run without dialer
    static readonly DIALER_SEQ_FINISHED = 'DIALER_SEQ_FINISHED'
}

export class TestSeq {

    seqid: string = ''
    testPointId: string = ''
    userId: string = ''
    stage: string = ''
    buildingId: string = ''
    pathId: string = ''
    pointId: string = ''
    cycle: number = 0
    testOrder: number = 0
    startTime: string = null
    endTime: string = null
    dialer: RootTest = null
    importTime: string = null
    status: string = null
    groupingfield:string=null
    updatedAt?: number = 0
    _rev?: string = ''
}